import { FC } from 'react';

import styles from './Conversation.module.scss';

import { useConversation, type ConversationRole } from './useConversation';

type ConversationProps = {
  role: ConversationRole;
  avatar?: boolean;
  singleCard?: boolean;
  showName?: boolean;
  forceSmall?: boolean;
  children: React.ReactNode;
};

export const Conversation: FC<ConversationProps> = props => {
  const args = useConversation(props);
  return (
    <ConversationView
      {...args}
      singleCard={props.singleCard}
      showName={props.showName}
      forceSmall={props.forceSmall}
    />
  );
};
type ConversationViewProps = {
  role: ConversationRole;
  name: string;
  body: React.ReactNode;
  displayAvatar?: boolean;
  singleCard?: boolean;
  showName?: boolean;
  forceSmall?: boolean;
};
export const ConversationView = ({
  body,
  name,
  role,
  displayAvatar,
  singleCard,
  showName = true,
  forceSmall,
}: ConversationViewProps) => {
  return (
    <div
      className={[
        styles.messageRoot,
        !displayAvatar ? styles.noAvatar : '',
        singleCard ? styles[`--single`] : '',
        !showName && !forceSmall ? styles[`--largeMessageRoot`] : '',
      ].join(' ')}
    >
      {showName && (
        <span className={[styles.messageName, styles[`--${role}`]].join(' ')}>{name}</span>
      )}
      <div className={[styles.char, styles[`--${role}`]].join(' ')}></div>
      <p className={styles.messageContent}>{body}</p>
    </div>
  );
};
